export default __webpack_public_path__ + "static/media/goa1.a75aa996.jpg";